import React from 'react';

function Header({ account, onConnect, onDisconnect, isConnecting }) {
  const formatAddress = (addr) => {
    if (!addr) return '';
    return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
  };

  return (
    <header className="header">
      <div className="header-bg"></div>
      <div className="header-content">
        <div className="logo">
          <div className="logo-coin">
            <div className="coin-face front">H</div>
            <div className="coin-face back">T</div>
          </div>
          <div className="logo-text">
            <h1>HEAD <span>or</span> TAILS</h1>
            <p className="tagline">Predict & Win 2X</p>
          </div>
        </div>
        
        <div className="wallet-section">
          {account ? (
            <div className="wallet-connected">
              <div className="wallet-info">
                <span className="pulse-dot"></span>
                <span className="address">{formatAddress(account)}</span>
              </div>
              <button className="btn btn-outline" onClick={onDisconnect}>
                Disconnect
              </button>
            </div>
          ) : (
            <button 
              className="btn btn-primary btn-glow" 
              onClick={onConnect}
              disabled={isConnecting}
            >
              {isConnecting ? (
                <><span className="spinner"></span> Connecting...</>
              ) : (
                <>🔗 Connect Wallet</>
              )}
            </button>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
